__webpack_require__.p = "https://s3.amazonaws.com/qa-dev2.365scores.com/";